var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _radialGradient5, _radialGradient6, _radialGradient7, _radialGradient8, _radialGradient9, _radialGradient10, _radialGradient11, _radialGradient12, _radialGradient13, _radialGradient14, _radialGradient15, _radialGradient16, _radialGradient17, _radialGradient18, _radialGradient19, _radialGradient20, _radialGradient21, _radialGradient22, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaGosloto6From45(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 74.469,
    cy: 17.457,
    r: 25.739,
    gradientTransform: "matrix(1 0 0 2.0244 0 -17.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#fcd34d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#fbc535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f9b934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    stopColor: "#f6b534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#eca734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    stopColor: "#db9133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#db9133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#cf751f"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 66.332,
    cy: 47.152,
    r: 33.615,
    gradientTransform: "matrix(.7832 -.6217 .3483 .4387 -2.042 67.706)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 65.921,
    cy: 33.025,
    r: 13.064,
    gradientTransform: "matrix(1 0 0 1.5445 0 -17.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#fcd34d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#fbc535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f9b934"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 76.502,
    cy: 37.26,
    r: 9.228,
    gradientTransform: "matrix(1 0 0 1.9837 0 -36.655)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#fcd34d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.426,
    stopColor: "#fbc535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#f9b934"
  }))), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 71.054,
    cy: 29.856,
    r: 23.288,
    gradientTransform: "matrix(1 0 0 .6011 0 11.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#fdf29b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#fdf29b",
    stopOpacity: 0
  }))), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 69.727,
    cy: 66.642,
    r: 12.305,
    gradientTransform: "matrix(1 0 0 .4975 0 33.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22"
  }))), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 95.665,
    cy: 38.673,
    r: 14.657,
    gradientTransform: "matrix(.6542 .7563 -.5753 .4976 55.33 -52.926)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 76.501,
    cy: 20.361,
    r: 7.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 73.907,
    cy: 18.066,
    r: 1.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 68.119,
    cy: 53.22,
    r: 21.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#f9b934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f6b534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#eca734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#db9133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#db9133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#cf751f"
  }))), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 72.955,
    cy: 43.292,
    r: 26.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fcd34d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd34d"
  }))), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 18.734,
    cy: 41.528,
    r: 41.416,
    gradientTransform: "matrix(.9164 .4003 -.3263 .7469 15.116 3.013)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#fcd34d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#fbc535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#f9b934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f6b534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#eca734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#db9133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#db9133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#cf751f"
  }))), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 36.805,
    cy: 38.88,
    r: 34.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 53.982,
    cy: 51.581,
    r: 5.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#d98531",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#bf6b1f"
  }))), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 30.502,
    cy: 46.652,
    r: 28.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fcd34d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcd34d"
  }))), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 27.989,
    cy: 44.175,
    r: 26.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#fbc535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#f9b934"
  }))), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 4.025,
    cy: 45.612,
    r: 6.762,
    gradientTransform: "matrix(.8247 .5656 -.4526 .6598 21.348 13.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 37.865,
    cy: 73.762,
    r: 17.721,
    gradientTransform: "matrix(.9574 -.2889 .2183 .7233 -14.487 31.349)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22"
  }))), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 37.563,
    cy: 74.828,
    r: 4.062,
    gradientTransform: "matrix(.9574 -.2889 .2183 .7233 -14.732 31.556)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22"
  }))), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 55.087,
    cy: 43.25,
    r: 5.575,
    gradientTransform: "matrix(.9917 -.1285 .3579 2.7629 -15.022 -69.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#3e2f22"
  }))), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 23.295,
    cy: 25.487,
    r: 12.148,
    gradientTransform: "matrix(.9544 -.2985 .0728 .2329 -.794 26.504)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#00020d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#04050e",
    stopOpacity: 0.908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#0e0c12",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#211a18",
    stopOpacity: 0.746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#3a2c21",
    stopOpacity: 0.669
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2f22",
    stopOpacity: 0.66
  }))), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 22.592,
    cy: 31.33,
    r: 24.661,
    gradientTransform: "matrix(.9521 -.3059 .2208 .6873 -5.835 16.706)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#fdf29b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777,
    stopColor: "#fdf29b",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 46.675c0 14.21-11.52 25.74-25.74 25.74-14.21 0-25.74-11.52-25.74-25.74s11.52-25.74 25.74-25.74S98 32.455 98 46.675z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.03 29.565c1.87-.63 5.16-1.54 8.63-1.15 5.3.6 9.85 1.7 12.5 3.09 2.65 1.4 4.49 2.51 5.28 5.91s-.13 11.76-1.18 15.66-1.75 6.87-4.59 8.43c-2.83 1.56-7.67 2.52-14.18 1.27-6.52-1.25-11.03-4.44-12.28-6.12s-2.32-3.19-1.23-10.28c.82-5.32 1.26-9.72 3.11-13.13.61-1.12 1.83-2.97 3.94-3.68z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m73.87 34.035-5.71-.59-6.9 11.1-.23 4.52 6.05.79-.62 5.18 4.18.7.79-5.19 1.75.2.44-4.67-1.36-.26 1.61-11.78zm-6.03 11.3-2.42-.25v-.52l3.1-4.74-.68 5.51z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m78.74 34.775 7.76 2.08v4.03h-.64l-4.33-.93-.76 2.42h.47s4.8.93 4.54 6.23c-.27 5.6-3.31 9.12-7.47 8.86-4.07-.25-4.69-2.8-4.69-2.8l1.22-4.5.64-.08s1.27 3.39 3.48 2.93c2.54-.54 3.1-3.99 2.59-5.72-.51-1.74-2.29-2.48-3.35-1.95-.72.36-1.1.8-1.1.8H76l-.25-.29 2.99-11.08z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.25 44.555s3.22-1.75 7.46-2.26 6.79 0 6.79 0 12.09-8.26 1.05-11.87c-10.66-3.49-19.6-2.78-22.09-.35s-2.71 7.15-2.43 8.19c.29 1.04 1.64-2.14 8.99 6.28",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.26 67.395c-3.3-.45-7.11-1.41-8.75-1.87-1.64-.45-2.77.06-3.45.85-.39.45-.4 1.73-.35 2.76 3.71 2.08 7.99 3.27 12.54 3.27 2.16 0 4.24-.29 6.24-.79.78-.92 1.33-1.84 1.24-2.52-.21-1.81-4.17-1.24-7.47-1.7z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m95.69 54.285 1.31-4.07h.74l.18-1.74-.81.05-.06-2.39.92-.09c-.05-2.13-.37-4.19-.9-6.15-.73.07-1.54.32-1.71 1.11-.34 1.53-.06 6.84-.91 10.23s-2.02 7.34-1.07 8.03c.29.21.69.3 1.12.35.39-.67.75-1.37 1.08-2.08-.23-.86-.31-1.95.11-3.25z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m81.44 24.365-2.37-.68-.28-1.3-1.3-.34s.9 1.78-4.3 1.4c-3.33-.24-3.9-1.35-3.79-2.34a24.29 24.29 0 0 0-2.73.46c-.05.57.01 1.2.36 1.73.85 1.3 3.05 1.41 5.65 1.36 2.6-.06 6 .68 8.09 1.3s3.92 1.35 5.03.45c.48-.39.59-.81.54-1.26-1.52-.99-3.15-1.82-4.87-2.48l-.03 1.7z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.68 22.165c1.22.47 3.24.3 3.24-.94-1.2-.17-2.41-.29-3.66-.29-.12 0-.24.02-.37.02-.01.49.16.97.79 1.21z",
    fill: "url(#i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m74.2 71.495.48-.69-6.33-2.56-1.84-.5-.51 1.68-2.7-.54-.3.91 2.59.59-.12.55 2.43.44.16-.38 6.14.5zm-5.89-1.31.13-.57h.63l2.21.82-2.97-.25z",
    fill: "url(#j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.26 20.935c-11.55 0-21.32 7.61-24.58 18.08 1.95-2.02 4.55-4.55 6.9-6.34 4.47-3.39 7.63-8.99 15.72-9.16s13.12.06 18.55 5.65c4.12 4.25 7.61 8.94 9.04 15.18-1.18-13.12-12.19-23.41-25.63-23.41z",
    fill: "url(#k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.99 50.565c0 15.74-12.76 28.5-28.5 28.5C14.76 79.055 2 66.305 2 50.565s12.76-28.5 28.5-28.5c15.73 0 28.49 12.76 28.49 28.5z",
    fill: "url(#l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 40.115c1.59-1.51 4.47-3.95 8.14-5.17 5.6-1.87 10.69-2.88 13.99-2.71 3.31.17 5.68.42 8.06 3.48 2.37 3.05 5.34 11.87 6.11 16.29.76 4.41 1.44 7.72-.68 10.6s-6.53 6.11-13.66 7.89c-7.12 1.78-13.15.68-15.18-.42-2.04-1.1-3.82-2.12-6.02-9.75-1.65-5.72-3.26-10.35-2.99-14.63.09-1.45.45-3.88 2.23-5.58z",
    fill: "url(#m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.28 53.885s-1.02 1.87 0 4.24c.37.87.89 1.1 1.38 1.04.6-1.89 1-3.85 1.19-5.89l-2.57.61z",
    fill: "url(#n)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05 40.875c1.92-4.64 7.92-11.48 18.09-14.7 10.18-3.22 18.43 2.09 18.43 2.09s3.79-.17 7.18 1.81c1.92 1.12 5.24 5.4 7.76 8.9-4.44-9.96-14.41-16.92-26.03-16.92C14.76 22.065 2 34.825 2 50.565c0 2.21.27 4.34.75 6.4-.34-6.6.95-12.83 2.3-16.09z",
    fill: "url(#o)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.34 47.955c-1.44-.9-4.11-.84-5.22-.2-1.1.64-.89.38-.89.38l2.67-10.09-6.36 1.82c-.13 1.06-3.35 10.48-2.97 16.16s4.79 10.22 9.92 9.58 7.85-4.07 7.68-8.95c-.16-4.88-3.39-7.8-4.83-8.7zm-2.8 12.43c-1.57.51-3.01-.47-3.82-2.25s-.64-3.44.21-4.45c.85-1.02 2.25-1.31 3.22-.76 0 0 1.95.64 2.46 3.31.37 1.91-.5 3.64-2.07 4.15z",
    fill: "url(#p)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26 59.765c-1.19-3.22-1.3-5.77-1.92-8.6s-1.98-3.62-2.77-3.04c-.13.09-.29.14-.45.2L2 50.565c0 1.11.09 2.21.21 3.29 1.03 1.16 2.16 2.87 2.62 5.1.33 1.63.35 3.07.2 4.35 1.04 2.06 2.3 3.99 3.78 5.73.45-.13.84-.29 1.05-.55 1.07-1.37-1.42-5.5-2.6-8.72z",
    fill: "url(#q)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.01 78.155c1.99-.89 5-1.36 8.18-2.12 1.88-.45 3.18-.63 4.19-.63 1.2-.68 2.36-1.43 3.45-2.27-.13-.71-.36-1.47-.77-2.07-.79-1.13-2.37-.17-6.11 1.53s-7.69 2.54-10.46 2.94-4.41.85-3.84 2.37a3.49 3.49 0 0 0 .54.94l3.3.21.43-.02c.21-.31.53-.63 1.09-.88z",
    fill: "url(#r)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.94 78.675a28.56 28.56 0 0 0 4.92-1.23c-.89.04-1.79.13-2.68.36a10.89 10.89 0 0 0-2.24.87z",
    fill: "url(#s)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m58.78 47.285.21 3.27c0 .79-.06 1.57-.12 2.34-.6.96-1.3 1.81-2.06 2.06-1.93.64-2.54-2.12-2.88-3.73s-1.19-6.19-2.8-10.18-1.87-5.68-1.19-6.79c.42-.68 2.08-.81 3.3-.81 1.11 1.47 2.06 3.07 2.88 4.74-.76.04-1.52.53-1.83 1.72-.52 1.98 1.42 7.35 3.12 8.21.69.37 1.11-.13 1.37-.83zm-1.48-2.62c.33-.03.65-.37.9-.71l-.68-2.4c-.52-.15-.97-.13-1.18.29-.68 1.35.28 2.88.96 2.82z",
    fill: "url(#t)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.68 25.665c1.67-.93 3.45-1.69 5.31-2.28-.27.75-1 1.63-2.91 2.11-.9.23-1.7.25-2.4.17zm16.21-3.48-2.39-.12c-.27 0-.53.03-.79.04l.34 1.08h-5.31s.06.34-.68 1.13c-.73.79-3.96 2.66-7.41 3.05-1.03.12-1.86.05-2.55-.1l-1.9 1.47c.06 1.02.16 2.06.35 2.48.42.93 2.12.68 4.16 0s5.26-2.21 8.74-2.97 8.06-1.02 8.06-3.14c-.02-.88-.3-1.95-.62-2.92z",
    fill: "url(#u)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44 46.135s-.73-6.62 1.87-9.5 7.86-4.86 13.06-5.77c5.2-.9 10.69.28 11.65 2.09s.59 9.49-2.83 11.08c-3.87 1.81-10.69 5.37-15.61 6.05-4.91.69-7.4 1.14-8.14-3.95z",
    fill: "url(#v)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaGosloto6From45);
export default __webpack_public_path__ + "static/media/russia_gosloto_6_from_45.bbd84b33d5356972e50aab24a95cfc5e.svg";
export { ForwardRef as ReactComponent };